<template>
  <div class="flex flex-col items-center gap-3 rounded-[var(--radius-lg)] border border-dashed border-border bg-card px-6 py-14 text-center">
    <div class="grid h-16 w-16 place-items-center rounded-full bg-secondary text-2xl text-muted-foreground">{{ glyph }}</div>
    <h3 class="text-lg font-bold">{{ title }}</h3>
    <p v-if="body" class="max-w-sm text-sm text-muted-foreground leading-relaxed">{{ body }}</p>
    <div v-if="$slots.action" class="mt-2">
      <slot name="action" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ glyph?: string; title: string; body?: string }>()
</script>
